import { render, staticRenderFns } from "./contactWay.vue?vue&type=template&id=5eba3dec&"
import script from "./contactWay.vue?vue&type=script&lang=js&"
export * from "./contactWay.vue?vue&type=script&lang=js&"
import style0 from "./contactWay.vue?vue&type=style&index=0&id=5eba3dec&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports